import React, { useRef, useCallback } from 'react';
import DropdownList from 'react-widgets/DropdownList';
import './ComboSelector.scss';

export const TipoClave = {
  ID: 'id',
  CODIGO: 'codigo',
};

const ComboSelector = (props) => {
  const {
    id,
    lista,
    valorActual,
    campoClave,
    campoDescripcion,
    isCargando,
    estilo,
    onItemElegido: onItemElegidoProperty,
  } = props;

  const onItemElegido = useCallback(
    (item) => {
      onItemElegidoProperty(item);
    },
    [onItemElegidoProperty]
  );

  const containerReference = useRef(null);

  const selectSingleMatch = useCallback(() => {
    console.log('selectSingleMatch', containerReference.current);
    try {
      let text = '';
      const element = containerReference.current;
      if (element) {
        // Prefer the visible search input used by react-widgets DropdownList
        let input = element.querySelector('input.rw-dropdownlist-search');
        if (!input) {
          // fallback to an input that is not aria-hidden
          input = [...element.querySelectorAll('input')].find(
            (index) => index.getAttribute('aria-hidden') !== 'true'
          );
        }
        if (input) {
          text = input.value.trim();
        } else {
          // fallback to displayed value span
          const span = element.querySelector('.rw-dropdown-list-value');
          text = span ? (span.textContent || '').trim() : (element.textContent || '').trim();
        }
      }
      if (!text || !Array.isArray(lista) || lista.length === 0) return false;

      // try exact match first
      const exact = lista.filter((it) => {
        const desc = campoDescripcion ? it[campoDescripcion] : it;
        if (desc === null || desc === undefined) return false;
        return String(desc).trim().toLowerCase() === text.toLowerCase();
      });
      if (exact.length > 0) {
        // if there is at least one exact match, pick the first
        onItemElegido(exact[0]);
        return true;
      }

      // fallback: if only one item contains the text, select it
      const contains = lista.filter((it) => {
        const desc = campoDescripcion ? it[campoDescripcion] : it;
        if (desc === null || desc === undefined) return false;
        return String(desc).toLowerCase().includes(text.toLowerCase());
      });
      if (contains.length > 0) {
        // if there is at least one partial match, pick the first (do not disturb while typing)
        onItemElegido(contains[0]);
        return true;
      }
    } catch {
      // ignore
    }
    return false;
  }, [lista, campoDescripcion, onItemElegido]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Tab') {
        // try to select synchronously before focus moves
        selectSingleMatch();
      }
    },
    [selectSingleMatch]
  );

  const handleBlur = useCallback(
    (e) => {
      selectSingleMatch();
    },
    [selectSingleMatch]
  );

  React.useEffect(() => {
    const element = containerReference.current;
    if (!element) return;
    const kd = (e) => {
      if (e.key === 'Tab') selectSingleMatch();
    };
    const fo = (e) => selectSingleMatch();
    element.addEventListener('keydown', kd, true);
    element.addEventListener('focusout', fo, true);
    return () => {
      element.removeEventListener('keydown', kd, true);
      element.removeEventListener('focusout', fo, true);
    };
  }, [selectSingleMatch]);

  // attach capture-phase listeners to ensure we receive Tab and focusout even if
  // child component stops propagation
  React.useEffect(() => {
    const element = containerReference.current;
    if (!element) return;
    const kd = (e) => {
      if (e.key === 'Tab') setTimeout(() => selectSingleMatch(), 0);
    };
    const fo = (e) => setTimeout(() => selectSingleMatch(), 0); // focusout bubbles
    element.addEventListener('keydown', kd, true);
    element.addEventListener('focusout', fo, true);
    return () => {
      element.removeEventListener('keydown', kd, true);
      element.removeEventListener('focusout', fo, true);
    };
  }, [selectSingleMatch]);

  return (
    <div ref={containerReference}>
      <DropdownList
        key={id}
        className={estilo}
        busy={isCargando}
        filter="contains"
        datakey={campoClave}
        textField={campoDescripcion}
        value={valorActual}
        data={lista}
        onChange={onItemElegido}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default ComboSelector;
